if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super()
        
        this.buttons = this.querySelectorAll('.tabs__button')
        this.tabs = this.querySelectorAll('.tabs__item')
        
        this.buttons.forEach(button => {
          button.addEventListener('click', this.changeTab.bind(this))
        })

        if (this.buttons.length) this.buttons[0].click()
      }

      changeTab (event) {
        const element = event.target
        this.buttons.forEach(button => {
          button.classList.remove('active')
        });

        this.tabs.forEach(tab => {
          tab.classList.remove('active')
        });

        element.classList.add('active')
        document.getElementById(element.dataset.tab).classList.add('active')
      }
    }
  )
}
